import React from 'react';
import PropTypes from 'prop-types';

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import { matchSorter } from 'match-sorter';

const filterOptions = (options, { inputValue }) => matchSorter(options, inputValue);

const OutputFieldsEditor = (props) => {
  return (
    <Autocomplete
      multiple
      limitTags={6}
      size="small"
      id="selected-output-fields"
      //filterOptions={logTypeFilterOptions}
      value={props.control||[]}
      onChange={(event, value)=>{
        const outputFields = value.length === 0 && !props.distinctCountsApplied ? ['id']:value
        props.onAddExtraOutputField(outputFields);
        props.interface.update('outputFields', outputFields)  
      }}
      options={props.fields||[]}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option}
      //getOptionLabel={(option) => logTypes[option].displayName || logTypes[option].name}
      //renderOption={(option, { selected }) => <LogTypeOption key={option} {...logTypes[option]} selected={selected} />}
      defaultValue={[]}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label="Fields"
        />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip label={option} {...getTagProps({ index })}  disabled={!props.distinctCountsApplied && option==='id'}/>
        ))
      }
    />
  )
}

// ** Proptypes ***********************
OutputFieldsEditor.propTypes = {
  controls: PropTypes.object.isRequired,
  interface: PropTypes.object.isRequired,
  fields: PropTypes.array.isRequired,
};

// ** Default props *******************
OutputFieldsEditor.defaultProps = {
};

export default OutputFieldsEditor
